import { queryGraphQL, } from 'common/util/query';
import { toQuery, nodeWithArgs } from 'common/util/queryHelper';

export const GET_STUDY_TESTAMENTS_FOR_INSTITUTION = 'GET_STUDY_TESTAMENTS_FOR_INSTITUTION';

export function getStudyTestamentsForInstitution(institutionId, title) {
    return (dispatch, getState) => {
        const query = nodeWithArgs('studyTestaments', {
            institutionId,
        }, [
            'id',
            'title',
            'text',
        ]);

        return queryGraphQL(toQuery(query)).then(results => {
            dispatch({
                type: GET_STUDY_TESTAMENTS_FOR_INSTITUTION,
                payload: results.data.studyTestaments,
            });
        });
    };
}

